import CurrencyJs from 'currency.js'

export const currency = (amount) => {
  return CurrencyJs(amount, { precision: 0, symbol: '' }).format()
}
